import React, { useState, useEffect } from 'react';
import { Table, Typography, Card, Space, Tag, Spin, Alert, Empty } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Title } = Typography;

const MRExamReport = () => {
  const [examRecords, setExamRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMRExamResults = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('正在获取MR考试成绩，无需认证');
        
        const res = await axios.get('/api/exams/mr-results/public');
        
        console.log('获取到MR考试成绩:', res.data);
        
        // 给每条记录添加一个 key 属性，用于 Table 组件
        const recordsWithKeys = res.data.map((record, index) => ({
          ...record,
          key: record._id || index
        }));
        
        setExamRecords(recordsWithKeys);
        setLoading(false);
      } catch (err) {
        console.error('获取MR考试成绩失败:', err);
        setError(`获取MR考试成绩失败: ${err.response?.status} ${err.response?.data?.msg || err.message}`);
        setLoading(false);
      }
    };

    fetchMRExamResults();
  }, []);

  const columns = [
    {
      title: '考试名称',
      dataIndex: 'examName',
      key: 'examName',
    },
    {
      title: '分数',
      dataIndex: 'score',
      key: 'score',
      sorter: (a, b) => a.score - b.score,
    },
    {
      title: '结果',
      dataIndex: 'passed',
      key: 'passed',
      render: passed => (
        <Tag color={passed ? 'success' : 'error'} icon={passed ? <CheckCircleOutlined /> : <CloseCircleOutlined />}>
          {passed ? '通过' : '未通过'}
        </Tag>
      ),
      filters: [
        { text: '通过', value: true },
        { text: '未通过', value: false },
      ],
      onFilter: (value, record) => record.passed === value,
    },
    {
      title: '考试时间',
      dataIndex: 'date',
      key: 'date',
      render: date => new Date(date).toLocaleString(),
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      defaultSortOrder: 'descend',
    },
  ];

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
        <p>加载MR考试成绩...</p>
      </div>
    );
  }

  if (error) {
    return <Alert message="错误" description={error} type="error" showIcon />;
  }

  return (
    <Card>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Title level={2}>MR操作考试成绩</Title>
        
        {examRecords.length > 0 ? (
          <Table 
            columns={columns} 
            dataSource={examRecords} 
            pagination={{ pageSize: 10 }}
            rowKey="key"
          />
        ) : (
          <Empty description="暂无MR操作考试记录" />
        )}
      </Space>
    </Card>
  );
};

export default MRExamReport; 